module.exports = __webpack_public_path__ + "img/banner.ed16f49c.png";